import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=318dc83b&scoped=true&"
import script from "./VendorSelect.vue?vue&type=script&lang=js&"
export * from "./VendorSelect.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelect.vue?vue&type=style&index=0&id=318dc83b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318dc83b",
  null
  
)

/* custom blocks */
import block0 from "./VendorSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports